(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('moment')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'moment'], factory) :
  (global = global || self, factory(global.functions = {}, global.React, global.moment));
}(this, (function (exports, react, moment) { 'use strict';

  moment = moment && Object.prototype.hasOwnProperty.call(moment, 'default') ? moment['default'] : moment;

  /**
   * Converts validation JSON response for form fields to our custom Error message shape
   * Example Response:
   *  fieldname: 'reason for error'
   *
   * Required shape:
   * {
   *  fieldname: 'reason for error'
   * }
   * @param {Object} errorData - the validation response object
   * @returns {Object} - the converted Form/FormField compatible validation shape
   */
  var errorObjectToString = function errorObjectToString(errorData) {
    var errorMessages = [];
    Object.keys(errorData).forEach(function (errPropName) {
      if (errorData[errPropName]) {
        if (Array.isArray(errorData[errPropName])) {
          errorMessages.push("".concat(errPropName, ": ").concat(errorData[errPropName].join(', ')));
        } else {
          errorMessages.push("".concat(errPropName, ": ").concat(errorData[errPropName]));
        }
      }
    });
    return errorMessages.join('; ');
  };

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;

    var _s, _e;

    try {
      for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * Function that counts occurrences of a substring in a string;
   * @param {String} string               The string
   * @param {String} subString            The sub string to search for
   * @param {boolean} [allowOverlapping]  Optional. (Default:false)
   * @author Vitim.us https://gist.github.com/victornpb/7736865
   * @see Unit Test https://jsfiddle.net/Victornpb/5axuh96u/
   * @see http://stackoverflow.com/questions/4009756/how-to-count-string-occurrence-in-string/7924240#7924240
   * @returns {number} number of times the string  has occurred
   */
  function stringOccurances(string, subString, allowOverlapping) {
    if (subString.length <= 0) return string.length + 1;
    var n = 0;
    var pos = 0;
    var step = allowOverlapping ? 1 : subString.length;

    while (pos >= 0) {
      pos = string.indexOf(subString, pos);

      if (pos >= 0) {
        n += 1;
        pos += step;
      } else break;
    }

    return n;
  }

  /**
   * Recursive depth-first search function to reduce nested object data into one flattened object.
   * Nested keys are joined with '[]' inside strings.
   * @param {Object} obj
   * @param {string|void} keyPrefix
   * @returns {Object} flattened object
   */
  function flattenObject(obj, keyPrefix) {
    return Object.keys(obj).reduce(function (flattened, key) {
      var flattenedKey = keyPrefix ? "".concat(keyPrefix, "[").concat(key, "]") : key;

      if (_typeof(obj[key]) === 'object') {
        var nestedFlattened = flattenObject(obj[key], flattenedKey);
        return Object.assign(flattened, nestedFlattened);
      }

      if (obj[key] === undefined) return flattened;
      return _objectSpread2(_objectSpread2({}, flattened), {}, _defineProperty({}, flattenedKey, obj[key]));
    }, {});
  }

  function serializeDataToString(obj) {
    var flattenedData = flattenObject(obj, 'constraint');
    return Object.keys(flattenedData).map(function (key) {
      return "".concat(key, "=").concat(flattenedData[key]);
    }).join('&');
  }

  function sanitizeInputForConstraints(input) {
    var inputSplit = [];
    var holdingString = '';
    var recursiveStore = '';
    var initialSplit = [];

    if (input.includes(':"') && stringOccurances(input, '"') % 2 === 0) {
      initialSplit = input.split(':"');
      holdingString = "".concat(initialSplit[0], ":").concat(initialSplit[1].split('"')[0]);
      recursiveStore = sanitizeInputForConstraints(
      /* +2 because indexOf returns it in array indexing (0 == first)
       * and substring accepts it in counting format (1 == first)
       * and then we add one more to get away from the first instance of
       * what we are searching for
       */
      input.substring(input.indexOf('"', input.indexOf('"') + 1) + 2));
      inputSplit = [holdingString].concat(_toConsumableArray(recursiveStore));
    } else {
      inputSplit = input.split(' ');
    }

    return inputSplit.filter(function (v) {
      return v !== '"';
    });
  }
  var unenclosedWhitespaceRegex = /\s+(?=(?:[^"]*"[^"]*")*[^"]*$)/g;

  function splitInput(input) {
    var split = input // split values that are separated by whitespace, except for those enclosed in ""
    .split(unenclosedWhitespaceRegex).filter(function (v) {
      return v.includes(':');
    }).join(':').split(':');
    return split;
  }

  function constrainSearch(input) {
    var result = input;
    var seperatorSplit = splitInput(input);
    var specialOperators = ['<>', '<', '>', '='];
    var columns = [];
    var constraintObj = {};

    if (seperatorSplit.length > 0) {
      columns = seperatorSplit.filter(function (element, index) {
        return index % 2 === 0;
      });

      if (columns.length) {
        // the api can constrain this
        constraintObj = columns.reduce(function (acc, value, index) {
          var toInsert = {};
          var searchValue = seperatorSplit[index * 2 + 1] || '';
          var constraintValues = [];
          var operator;

          if (searchValue !== '' && specialOperators.some(function (op) {
            return searchValue.includes(op);
          })) {
            operator = specialOperators.find(function (op) {
              return searchValue.includes(op);
            });
            constraintValues = searchValue.split(operator).filter(function (s) {
              return !!s;
            });
          } else {
            // split values that are separated by comma, except for those enclosed in ""
            constraintValues = searchValue.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/g).filter(function (s) {
              return !!s;
            });
          }

          constraintValues = constraintValues.map(function (cV) {
            if (stringOccurances(cV, '"') > 1) {
              var firstQuote = cV.indexOf('"');
              return cV.substring(firstQuote + 1, cV.indexOf('"', firstQuote + 1));
            }

            return cV;
          });

          if (constraintValues.length === 1) {
            var _constraintValues = constraintValues,
                _constraintValues2 = _slicedToArray(_constraintValues, 1),
                v = _constraintValues2[0];

            if (operator) {
              toInsert = {
                op: operator,
                v: v
              };
            } else {
              toInsert = v;
            }
          } else {
            var constraintvaluesObj = _objectSpread2({}, constraintValues);

            toInsert = {
              op: operator,
              v: constraintvaluesObj
            };
          }

          return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, value, toInsert));
        }, {});
        result = serializeDataToString(constraintObj);
      }
    }

    return result;
  }

  /**
   * Uses the useRef hook internally for storing the previous value
   * @returns {any} previous value
   */
  function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    var ref = react.useRef(); // Store current value in ref

    react.useEffect(function () {
      ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)

    return ref.current;
  }

  /**
   * @class MomentWrapper
   * @description Singleton convenience class wrapper for the 'moment' library
   */

  var MomentWrapper = /*#__PURE__*/function () {
    function MomentWrapper() {
      _classCallCheck(this, MomentWrapper);
    }

    _createClass(MomentWrapper, null, [{
      key: "getInstance",
      value:
      /**
       * Returns the Moment instance and sets the locale on it
       * @param {string} locale the locale to use when getting the Moment instance
       */
      function getInstance(locale) {
        if (!this.momentInstance) {
          if (locale) moment.locale(locale);
          this.momentInstance = moment;
        }

        return this.momentInstance;
      }
      /**
       * sets or changes the locale of the current Moment instance
       * @param {string} locale the locale to use when getting the Moment instance
       */

    }, {
      key: "setLocale",
      value: function setLocale(locale) {
        this.getInstance().locale(locale);
      }
    }]);

    return MomentWrapper;
  }();
  /**
   * Returns the Moment instance and sets the locale on it
   * @param {string} locale the locale to use when getting the Moment instance
   */


  function getMoment(locale) {
    return MomentWrapper.getInstance(locale);
  }
  /**
   * Formats a Unix timestamp to a Date string
   * @param {number} item - the Unix epoch number to be formatted
   * @param {string} dateFormat - the Moment DateFormat to be applied - default: L
   * @returns {string} the formatted date string or a '-' if the input is untruthy
   */

  function parseDate() {
    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : moment().unix();
    var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
    return item ? MomentWrapper.getInstance().unix(item).format(dateFormat).toString() : '-';
  }

  /**
   * Returns the JWT token this is stored in localStorage under key '_tk'
   * @param {boolean} withBearer should be set to TRUE if the 'Bearer' part of the token string is required
   * @param {string} key the localStorage key to get stored token from
   * @returns {string} token value
   */
  function getTokenFromStorage() {
    var withBearer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_tk';
    if (typeof window === 'undefined') return null;
    var token = window.localStorage.getItem(key);
    if (typeof token !== 'string') return null;

    if (withBearer) {
      return token;
    }

    return token.substr(7);
  }

  /**
   * Checks if the given Object has a property matching the given name
   * @param {Object} object the object to be inspected
   * @param {string} name the name of the property to be checked for in the Object
   * @returns {boolean} result of the evaluation
   */
  function hasOwn(object, name) {
    if (!object) return false;
    return Object.prototype.hasOwnProperty.call(object, name);
  }

  /**
   * Checks if a value is not null, undefined or an empty string
   * @param {any} value: value checked
   * @returns {boolean} result of the evaluation
   */
  var hasValue = (function (value) {
    if (Array.isArray(value)) {
      return !!value.length;
    }

    return value !== null && value !== undefined && value !== '';
  });

  /**
   * Native smooth scrolling for Chrome, Firefox & Opera
   * @see: https://caniuse.com/#feat=css-scroll-behavior
   * @param {DOMElement} elem the valid dom element to call the 'scroll' function on
   */
  var nativeSmoothScrollTo = function nativeSmoothScrollTo(elem) {
    elem.scroll({
      behavior: 'smooth',
      left: 0,
      top: 0
    });
  };
  /**
   * Polyfilled smooth scrolling for IE, Edge & Safari
   * @param {DOMElement} elm element used as refernce when scrolling
   * @param {number} duration the time in miliseconds to animate the scrolling
   * @see Issue: https://stackoverflow.com/questions/52276194/window-scrollto-with-options-not-working-on-microsoft-edge
   */


  var smoothScrollTo = function smoothScrollTo(elm, duration) {
    var to = elm.offsetTop; // eslint-disable-next-line

    var element = elm,
        start = elm.scrollTop,
        change = to - start,
        startDate = +new Date(); // t = current time
    // b = start value
    // c = change in value
    // d = duration

    var easeInOutQuad = function easeInOutQuad(t, b, c, d) {
      // eslint-disable-next-line
      t /= d / 2;
      if (t < 1) return c / 2 * t * t + b; // eslint-disable-next-line

      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };

    var animateScroll = function animateScroll() {
      var currentDate = +new Date();
      var currentTime = currentDate - startDate;
      element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration), 10);

      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        element.scrollTop = to;
      }
    };

    animateScroll();
  }; // detect support for the behavior property in ScrollOptions


  var supportsNativeSmoothScroll = ('scrollBehavior' in document.documentElement.style);
  /**
   * Scrolls to top of Given DOM Element
   * @param {DOMElement} element to the element to stop to the top of
   */

  var scrollToElement = function scrollToElement(element) {
    if (typeof window === 'undefined') return;

    if (element && element.scrollTop > 0) {
      try {
        if (supportsNativeSmoothScroll) {
          nativeSmoothScrollTo(element);
        } else {
          smoothScrollTo(element, 600);
        }
      } catch (e) {
        // eslint-disable-next-line
        console.warn('Unable to Scroll to Top of Element');
      }
    }
  };
  /**
   * Scroll to top of given query selector resolved element
   * @param {string} selector query selector string to query a DOM element by
   */

  var scrollToSelector = function scrollToSelector(selector) {
    scrollToElement(document.querySelector(selector));
  };
  var smoothScrollTo$1 = (function (elem) {
    scrollToElement(elem);
  });

  var user = "[a-zA-Z0-9_\\-\\.\\+\\^!#\\$%&*+\\/\\=\\?\\`\\|\\{\\}~\\']+";
  var domain = '(?:(?:[a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\\-]*[a-zA-Z0-9])\\.?)+';
  var ipv4 = '[0-9]{1,3}(\\.[0-9]{1,3}){3}';
  var ipv6 = '[0-9a-fA-F]{1,4}(\\:[0-9a-fA-F]{1,4}){7}';
  var EmailTest = new RegExp("^".concat(user, "@(").concat(domain, "|(\\[(").concat(ipv4, "|").concat(ipv6, ")\\]))$"));
  /**
   * Checks if the given string matches good known Email validation patterns
   * @param {string} value: email to be validated
   * @returns {boolean} result of the evaluation
   */

  function validateEmail(value) {
    return EmailTest.test(value);
  }

  var PhoneTest = /^\+(\d{11})$/;
  /**
   * Checks wether the given string value matches international telephone formatting
   * @param {string} value: phone number to be validated
   * @returns {boolean} result of the evaluation
   */

  function validatePhone(value) {
    // strip all spaces from value
    var stripped_value = value.replace(/\s/g, '');
    return PhoneTest.test(stripped_value);
  }

  var WebsiteTest = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
  /**
   * Checks whether the given string matches good known website naming schemes
   * @param {string} value the website to be validated
   * @returns {boolean} result of the evaluation
   */

  function validateWebsite(value) {
    return WebsiteTest.test(value);
  }

  /**
   * Creates closure for delaying function
   * @param {number} delay the number of milliseconds to delay the function call
   * @returns {Function} function to perform debouncing
   */
  function debounced(delay) {
    var timer = null;
    return function (fn) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var context = this;

      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }

  /**
   * Checks if a value has any props
   * @param {Object} obj: object checked
   * @returns {boolean} result of the evaluation
   */
  var isObjectEmpty = (function () {
    var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return !Object.keys(obj).length;
  });

  /**
   * Shifts element array to designated position in array.
   * @param {array} array: array that is rearranged
   * @param {number} fromIndex: index of element to move
   * @param {number} toIndex: index where element shifts to
   * @returns {array} the new rearranged array
   */
  function moveItemInArray(array, fromIndex, toIndex) {
    if (fromIndex === toIndex) return array;

    var newArray = _toConsumableArray(array);

    var target = newArray[fromIndex];
    var inc = toIndex < fromIndex ? -1 : 1;

    for (var i = fromIndex; i !== toIndex; i += inc) {
      newArray[i] = newArray[i + inc];
    }

    newArray[toIndex] = target;
    return newArray;
  }

  /**
   * Removes a key from an Object
   * @param {string} key - the object key to be removed
   * @param {Object} oldObject - the object to perform the key removal on
   * @returns {Object} - a new modified object less the removed key
   */
  var removeKeyFromObject = (function (key, oldObject) {
    var newObject = _objectSpread2({}, oldObject);

    delete newObject[key];
    return newObject;
  });

  /**
   * Replaces underscores with spaces
   * @param {string} str: string to modify
   * @returns {string} the new modified string
   */
  function replaceUnderscoreWithSpace(str) {
    return str.replace(/_/g, ' ');
  }
  /**
   * Capitalizes first character of every word
   * @param {string} str: string to modify
   * @returns {string} the new modified string
   */

  function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  /**
   * Replaces underscores with spaces and capitalizes the first character of
   * each word
   * @param {string} str: string to modify
   * @returns {string} the new modified string
   */

  function snakeCaseToTitleCase(str) {
    return toTitleCase(replaceUnderscoreWithSpace(str));
  }
  /**
   * Removes white spaces in string
   * @param {string} str: string to modify
   * @returns {string} the new modified string
   */

  function removeWhiteSpaces(str) {
    return str.replace(/\s/g, '');
  }

  exports.constrainSearch = constrainSearch;
  exports.debounced = debounced;
  exports.errorObjectToString = errorObjectToString;
  exports.flattenObject = flattenObject;
  exports.getMoment = getMoment;
  exports.getTokenFromStorage = getTokenFromStorage;
  exports.hasOwn = hasOwn;
  exports.hasValue = hasValue;
  exports.isObjectEmpty = isObjectEmpty;
  exports.moveItemInArray = moveItemInArray;
  exports.parseDate = parseDate;
  exports.removeKeyFromObject = removeKeyFromObject;
  exports.removeWhiteSpaces = removeWhiteSpaces;
  exports.replaceUnderscoreWithSpace = replaceUnderscoreWithSpace;
  exports.sanitizeInputForConstraints = sanitizeInputForConstraints;
  exports.scrollToSelector = scrollToSelector;
  exports.smoothScrollTo = smoothScrollTo$1;
  exports.snakeCaseToTitleCase = snakeCaseToTitleCase;
  exports.stringOccurances = stringOccurances;
  exports.toTitleCase = toTitleCase;
  exports.usePrevious = usePrevious;
  exports.validateEmail = validateEmail;
  exports.validatePhone = validatePhone;
  exports.validateWebsite = validateWebsite;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
